import React, { useState } from "react";
import { Button, Fade, Modal, Backdrop } from "@material-ui/core";
import useStyles from "./connectWalletButtonStyles.js";

function ConnectWalletButton({handleOpen, text, padding}) {
  const classes = useStyles();
  return (
    <div>
      <Button
        disableRipple
        onClick={handleOpen}
        className={`${(text=="Wrong Network")?classes.wrongWalletButton:text=="Change"?classes.changeWalletButton:classes.connectWalletButton}`}
        style={{padding:`${padding}`}}
      >
        {text}
      </Button>
    </div>
  );
}

export default ConnectWalletButton;
